export default "__VITE_ASSET__d33kKPwR__"